import { activeTabSignal } from '../../state/ui.store';
import { actionsSignal } from '../../state/ai.store';
import type { TabType } from '../../types/common';
import { MessageSquare, CheckSquare, FileText } from 'lucide-preact';

import { activeContactSignal, ensureMessagesLoaded } from '../../state/contacts.store';
import { syncUrlWithState } from '../../services/router';

export function WorkspaceTabs() {
  const activeTab = activeTabSignal.value;
  const pendingActionsCount = actionsSignal.value.filter(a => a.status === 'pending').length;

  const setTab = (tab: TabType) => {
    activeTabSignal.value = tab;
    syncUrlWithState();
    if (tab === 'tab-messages' && activeContactSignal.value) {
      ensureMessagesLoaded(activeContactSignal.value);
    }
  };

  return (
    <div class="workspace-tabs-bar">
      <button
        onClick={() => setTab('tab-messages')}
        class={`tab-btn ${activeTab === 'tab-messages' ? 'active' : ''}`}
      >
        <MessageSquare class="w-3.5 h-3.5" />
        <span>Mensagens</span>
      </button>

      <button
        onClick={() => setTab('tab-actions')}
        class={`tab-btn ${activeTab === 'tab-actions' ? 'active' : ''}`}
      >
        <CheckSquare class="w-3.5 h-3.5 text-amber-300" />
        <span class="hidden sm:inline">Ações Pendentes</span>
        <span class="sm:hidden">Pendências</span>
        <span class="px-1.5 py-0.2 rounded-full text-[10px] bg-amber-500/25 text-amber-200 border border-amber-400/40 font-bold">
          {pendingActionsCount}
        </span>
      </button>

      <button
        onClick={() => setTab('tab-summaries')}
        class={`tab-btn ${activeTab === 'tab-summaries' ? 'active' : ''}`}
      >
        <FileText class="w-3.5 h-3.5 text-cyan-300" />
        <span class="hidden sm:inline">Resumos & Projetos</span>
        <span class="sm:hidden">Resumos</span>
      </button>
    </div>
  );
}
